import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { usePlusDetailedListingPopup } from "~/components/plus/detailed-listing-popup/hooks";
import type { plusAuthorCardAuthor$key } from "~/queries/__generated__/plusAuthorCardAuthor.graphql";

import {
  Expertise,
  StyleAuthorCardContainer,
  StyleAuthorInfoContainer,
  StyleAvatarContainer,
  StyledAuthorAvatar,
  StyledAuthorBio,
  StyledStyleAuthorName,
  StyleNameContainer,
} from "./styles";

export type Props = {
  reference: plusAuthorCardAuthor$key;
};

export const PlusAuthorCard: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const { handleOpen } = usePlusDetailedListingPopup();
  const author = useFragment(
    graphql`
      fragment plusAuthorCardAuthor on Author {
        ...authorAvatarAuthor
        ...authorNameAuthor
        ...authorBioAuthor
        areaOfExpertise
      }
    `,
    reference_,
  );

  const handleAuthorClick = (entityUuid: string) => {
    handleOpen({ entityUuid, type: "author" });
  };

  return (
    <StyleAuthorCardContainer>
      <StyleAvatarContainer>
        <StyledAuthorAvatar
          height={120}
          reference={author}
          width={120}
          placeholder
          withoutLink
          onClick={handleAuthorClick}
        />
      </StyleAvatarContainer>
      <StyleAuthorInfoContainer>
        <StyleNameContainer>
          <StyledStyleAuthorName reference={author} withoutLink onClick={handleAuthorClick} />
          {!!author.areaOfExpertise?.length && (
            <>
              <span>|</span>
              <Expertise>{author.areaOfExpertise.join(", ").trim()}</Expertise>
            </>
          )}
        </StyleNameContainer>
        <StyledAuthorBio reference={author} />
      </StyleAuthorInfoContainer>
    </StyleAuthorCardContainer>
  );
};

PlusAuthorCard.displayName = "PlusAuthorCard";
